import axios from "axios";

export function fetchEmployees(data = {}) {
    return axios.get(data.url, {params: data.params})
}
export function getSchedules(data = {}) {
    return axios.get(data.url, {params: data.params})
}